<div class="row">
  <div class="col-12">
    <div class="content-header">Basic Tables</div>
    <p class="content-sub-header mb-1">All table styles are inherited in Bootstrap 4.3.1, meaning any nested tables will be styled in the same manner as the parent.</p>
  </div>
</div>
<!--Basic Table Starts-->
<section id="simple-table">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Default Table</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>For basic styling add <code>.table</code> to any <code>&lt;table&gt;</code>.</p>
            <div class="table-responsive">
              <table class="table m-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Larry</td>
                    <td>the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Basic Table Ends-->

<!--Inverse Table Starts-->
<section id="inverse-table">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Inverse Table</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>You can also invert the colors (with light text on dark backgrounds) with <code>.table-dark</code>.</p>
            <div class="table-responsive">
              <table class="table table-dark m-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Larry</td>
                    <td>the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Inverse Table Ends-->


<!--Light table starts-->
<section id="light">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Light Table Head</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.thead-light</code> for thead to appear it as a light background.</p>
            <div class="table-responsive">
              <table class="table m-0">
                <thead class="thead-light">
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Larry</td>
                    <td>the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Light table Ends-->

<!--Dark table starts-->
<section id="dark">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Dark Table Head</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.thead-dark</code> for thead to appear it as a dark background.</p>
            <div class="table-responsive">
              <table class="table m-0">
                <thead class="thead-dark">
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Larry</td>
                    <td>the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Dark table Ends-->


<!--Striped rows Light Starts-->
<section id="striped-light">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Light Striped Rows</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.table-striped</code> to add striped rows to any table row.</p>
            <div class="table-responsive">
              <table class="table table-striped m-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Larry</td>
                    <td>the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Striped rows Light Ends-->

<!--Striped rows Inverse Starts-->
<section id="striped-inverse">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Dark Striped Rows</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.table-striped.table-dark</code> to add striped rows to any table row.</p>
            <div class="table-responsive">
              <table class="table table-striped table-dark m-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Larry</td>
                    <td>the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Striped rows Inverse Ends-->

<!-- Bordered Table starts -->
<section id="bordered-table">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Bordered Table</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Add <code>.table-bordered</code> for borders on all sides of the table and cells.</p>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">First</th>
                    <th scope="col">Last</th>
                    <th scope="col">Handle</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td colspan="2">Larry the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Bordered Table ends -->

<!--Hoverable Rows Starts-->
<section id="hoverable-rows">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Hoverable rows</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Add <code>.table-hover</code> to enable hover state on table rows.</p>
            <div class="table-responsive">
              <table class="table table-hover m-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td colspan="2">Larry the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Hoverable rows Ends-->

<!--Small Tables Starts-->
<section id="small-table">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Small table</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Add <code>.table-sm</code> to make tables more compact by cutting padding in table cells.</p>
            <div class="table-responsive">
              <table class="table table-sm m-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td colspan="2">Larry the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Small Tables Ends-->

<!--Contextual classes Starts-->
<section id="contenxtual">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Contextual classes</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use contextual classes to color table rows or individual cells.</p>
            <div class="table-responsive">
              <table class="table m-0">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Column heading</th>
                    <th>Column heading</th>
                    <th>Column heading</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-active">
                    <th scope="row">Active</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                  <tr>
                    <th scope="row">Default</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                  <tr class="table-primary">
                    <th class="dark" scope="row">Primary</th>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                  </tr>
                  <tr class="table-secondary">
                    <th class="dark" scope="row">Secondary</th>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                  </tr>
                  <tr class="table-success">
                    <th class="dark" scope="row">Success</th>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                  </tr>
                  <tr class="table-danger">
                    <th class="dark" scope="row">Danger</th>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                  </tr>
                  <tr class="table-warning">
                    <th class="dark" scope="row">Warning</th>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                  </tr>
                  <tr class="table-info">
                    <th class="dark" scope="row">Info</th>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                  </tr>
                  <tr class="table-light">
                    <th class="dark" scope="row">Light</th>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                  </tr>
                  <tr class="table-dark">
                    <th class="dark" scope="row">Dark</th>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                    <td class="dark">Column content</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Contextual classes Ends-->

<!--Responsive tables Starts-->
<section id="responsive-table">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Responsive tables</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Responsive tables allow tables to be scrolled horizontally with ease. Make any table responsive across all viewports by wrapping a <code>.table</code> with <code>.table-responsive</code>. Or, pick a maximum breakpoint with which to have a responsive table up to by using <code>.table-responsive-&#123;size&#125;</code>.</p>
            <table class="table table-responsive mb-0">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Heading 1</th>
                  <th scope="col">Heading 2</th>
                  <th scope="col">Heading 3</th>
                  <th scope="col">Heading 4</th>
                  <th scope="col">Heading 5</th>
                  <th scope="col">Heading 6</th>
                  <th scope="col">Heading 7</th>
                  <th scope="col">Heading 8</th>
                  <th scope="col">Heading 9</th>
                  <th scope="col">Heading 10</th>
                  <th scope="col">Heading 11</th>
                  <th scope="col">Heading 12</th>
                  <th scope="col">Heading 13</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Michael Right</th>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                </tr>
                <tr>
                  <th>Michael Right</th>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                </tr>
                <tr>
                  <th>Michael Right</th>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                  <td>Table cell</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Responsive tables Ends-->
